import SummaryItem from "./SummaryItem";
import {IconCardSettings} from "../../../../components/buttons/IconButtons";
import {useSelector} from "react-redux";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 30 de 04 de 2026
 */

const SummaryContainerSecurity = ({data,t}) => {
    const {getAntiPassBackType, getEscortMode} = useSelector((state) => state.DevicesSlice);
    const {getAllMedia} = useSelector((state) => state.CommonsSlice);

    const getAntiPassBackTypeNameById = (id) => {
        if (!id || !Array.isArray(getAntiPassBackType)) return '';

        const found = getAntiPassBackType.find(item => item.id === id);
        return t(found?.name) || '';
    };

    const getAllMediaNameById = (id) => {
        if (!id || !Array.isArray(getAllMedia)) return '';

        const found = getAllMedia.find(item => item.id === id);
        return t(found?.name) || '';
    };

    const getEscortModeNameById = (id) => {
        if (!id || !Array.isArray(getEscortMode)) return '';

        const found = getEscortMode.find(item => item.id === id);
        return t(found?.name) || '';
    };

    const itemsA = [
        {
            label: 'anti_pass_back',
            value: getAntiPassBackTypeNameById(data?.antiPassBackType)
        },
        {
            label: 'anti_pass_back_time',
            value: data?.antiPassBackTime
        },
        {
            label: 'anti_pass_back_alert_by',
            value: getAllMediaNameById(data?.antiPassBackAlert)
        },
        {
            label: 'escort',
            value: getEscortModeNameById(data?.escortMode)
        }
    ];

    const itemsB = [
        {
            label: 'sync_time',
            value: data?.syncTime
        },
        {
            label: 'real_time_sync',
            value: t(data?.realTimeSync ? 'YES' : 'NO')
        },
        {
            label: 'sync_at_time',
            value: data?.syncAtTime
        },
        {
            label: 'request_signature',
            value: data?.requestSignature
        },
        {
            label: 'request_signature_every',
            value: data?.requestSignatureAlways
        },
        {
            label: 'validation_number',
            value: data?.validationNumber
        },
    ];
    return (
         <div className={"row p-12px"}>
            <div className={"maxw-5 col-1 p-0 d-none d-md-block"}>
                <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center
                align-items-center w-44px h-44px'>
                    <IconCardSettings width={24} height={24}/>
                </div>
            </div>
         <div className={" col-12 col-md-11 row p-0"}>
            <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                {itemsA.map((item) => (
                    <SummaryItem
                        label={item.label}
                        value={item.value}
                        t={t}
                    />
                ))}

            </div>
            <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                {itemsB.map((item) => (
                    <SummaryItem
                        label={item.label}
                        value={item.value}
                        t={t}
                    />
                ))}
            </div>
            </div>
        </div>
    )

}

export default SummaryContainerSecurity
